// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pdAl","left":"styles_left__1KhbB","desktopActions":"styles_desktopActions__1hCKq","title":"styles_title__2M0DN"};